import { FC, useEffect, useRef, useState } from 'react';
import { Popup, Form, Selector, Button, FormInstance } from 'react-vant';
import {
  houseDecorationList,
  houseFacingList,
  houseLayoutList,
  houseStoreyList,
  houseTypeList,
} from '@/pages/ServicesMore/config';

interface SelectHouseTagProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: (values: any) => void;
  defaultData: {};
}

const SelectHouseTag: FC<SelectHouseTagProps> = (props) => {
  const { visible, onClose, onSuccess, defaultData } = props;
  // console.log("tas", defaultData)
  const [form] = Form.useForm();
  const formRefTag = useRef<FormInstance>(null);

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (visible) {
      setIsMounted(true);
    }
  }, [visible])

  useEffect(() => {
    if (visible &&  isMounted &&  formRefTag.current && props.defaultData) {
      console.log("tas", defaultData)
      formRefTag.current?.setFieldsValue(defaultData)
    }
  }, [isMounted, visible, props.defaultData])
  
  const onFinish = (values: any) => {
    console.log(values)
    onSuccess(values)
  }
  return (
    <Popup
      visible={visible}
      onClose={onClose}
      position={'right'}
      style={{ height: '100%', width: '80%' }}
    >
      <Form
        layout={'vertical'}
        ref={formRefTag}
        form={form}
        onFinish={onFinish}
        footer={
          <div style={{ margin: 16 }}>
            <Button round nativeType="submit" type="primary" block>
              提交
            </Button>
          </div>
        }
      >
        <Form.Item label={'房屋类型'} name={'roomType'} rules={[{ required: true, message: '请选择' }]}>
          <Selector
            style={{ '--rv-selector-margin': '6px' }}
            options={houseTypeList}
            
          />
        </Form.Item>
        <Form.Item label={'房屋朝向'} name={'facing'} rules={[{ required: true, message: '请选择' }]}>
          <Selector
            style={{ '--rv-selector-margin': '6px' }}
            options={houseFacingList}
          />
        </Form.Item>
        <Form.Item label={'装修情况'} name={'decoration'} rules={[{ required: true, message: '请选择' }]}>
          <Selector
            style={{ '--rv-selector-margin': '6px' }}
            options={houseDecorationList}
          />
        </Form.Item>
        <Form.Item label={'房屋布局'} name={'layout'} rules={[{ required: true, message: '请选择' }]}>
          <Selector
            style={{ '--rv-selector-margin': '6px' }}
            options={houseLayoutList}
          />
        </Form.Item>
        <Form.Item label={'房屋楼层'} name={'floor'} rules={[{ required: true, message: '请选择' }]}>
          <Selector
            style={{ '--rv-selector-margin': '6px' }}
            options={houseStoreyList}
          />
        </Form.Item>
      </Form>
    </Popup>
  );
};

export default SelectHouseTag;
